import styled from '@emotion/styled';
import { withTheme } from '@emotion/react';
import { mq } from '@styles/breakpoints';
import { ThemeProps } from '@theme/base';
import { BenefitGroupComponent } from '@model/content';
import { Icon } from '@components/common/generic-icon';
import { useI18NextContext } from '@components/hooks';

const Container = styled.div(({ theme }: ThemeProps) => ({
  background: theme.custom.colors.group10.lighter,
  borderBottom: `1px solid ${theme.custom.colors.group10.light}`,
  width: '100%',
  position: 'relative',
  ['&:after']: {
    content: '""',
    height: '100%',
    right: 0,
    width: theme.custom.spacing.xLarge,
    background: `linear-gradient(to right, rgba(255,255,255,0), ${theme.custom.colors.white})`,
    position: 'absolute',
    top: 0,
    [mq.medium]: {
      display: 'none'
    }
  }
}));

const Inner = styled.div({
  overflowX: 'auto',
  width: '100%',
  [mq.medium]: {
    display: 'flex',
    justifyContent: 'center'
  }
});

const TrustItemWrapper = styled.div(({ theme }: ThemeProps) => ({
  alignContent: 'center',
  alignItems: 'center',
  display: 'flex',
  fontSize: '1.6rem',
  height: 60,
  justifyContent: 'flex-start',
  padding: `0 ${theme.custom.spacing.large}px`,
  [mq.medium]: {
    justifyContent: 'space-between',
    width: theme.custom.contentSizes.maxContentWidth
  }
}));

const TrustItem = styled.div(({ theme }: ThemeProps) => ({
  display: 'flex',
  alignItems: 'center',
  paddingRight: theme.custom.spacing.large,
  whiteSpace: 'nowrap',
  ['i']: {
    fontSize: '3rem',
    marginRight: theme.custom.spacing.small
  }
}));

export const TrustBar = withTheme(({ benefits }: BenefitGroupComponent) => {
  const t = useI18NextContext();

  const renderTrustItems = (items) =>
    items.map(({ icon, title }) => (
      <TrustItem key={title}>
        <Icon name={icon} />
        {t(title)}
      </TrustItem>
    ));
  return (
    <Container>
      <Inner>
        <TrustItemWrapper>{renderTrustItems(benefits)}</TrustItemWrapper>
      </Inner>
    </Container>
  );
});
